// extracted by mini-css-extract-plugin
export default {"root":"FormAlert_root__siwBb","title":"FormAlert_title__cbkS+","message":"FormAlert_message__B3L+w"};